import axios from 'axios';
import { httpClient } from '../lib/axios';

const pincode = localStorage.getItem('city_pincode');
const cityId = localStorage.getItem('city_id');
const counterId = localStorage.getItem('counter_id');

export const api = {
  register: async (payload) => {
    return await httpClient.post('user/', payload);
  },
  get_cities: async () => {
    return await httpClient.get('city/');
  },
  get_categories: async () => {
    return await httpClient.get('category/');
  },
  get_products: async (
    page_number,
    page_size,
    search,
    category = '',
    sub_category = null,
    order,
  ) => {
    return await httpClient.get(
      `/product/?pincode=${pincode}&page_size=${page_size}&page_number=${page_number}&search=${search}&category_id=${category}&${sub_category ? 'sub_category_id=' + sub_category : ''
      }${order ? 'order_by=' + order : ''}`,
    );
  },
  get_delivery_time_variants: () => {
    return httpClient.get("/delivery-time/");
  },

  get_bundles: async () => {
    return await httpClient.get("bundle/");
  },
  add_bundle_to_cart: async (bundle_id) => {
    return await httpClient.post(
      `cart/?add_bundle=true&city_id=${cityId}&counter_id=${counterId}`,
      { bundle_id }
    );
  },
edit_cart_bundle: async (payload) => {
  return await httpClient.post(
    `cart/?edit_bundle=true&city_id=${cityId}&counter_id=${counterId}`,
    payload
  );
},

remove_cart_bundle: async (payload) => {
  return await httpClient.post(
    `cart/?remove_bundle=true&city_id=${cityId}&counter_id=${counterId}`,
    payload
  );
},

  get_product: async (id) => {
    return await httpClient.get(`product/?product_id=${id}`);
  },
  change_password: async (payload) => {
    return httpClient.put(`/user/?change_password=true`, payload);
  },
  add_to_cart: async (payload) => {
    return await httpClient.post(`cart/?add_item=true&city_id=${cityId}&counter_id=${counterId}`, payload);
  },
  get_cart: async (payload) => {
    return await httpClient.get(`cart/?city_id=${cityId}&counter_id=${counterId}`, payload);
  },
  update_cart: async (payload) => {
    return await httpClient.post(`cart/?edit_item=true&city_id=${cityId}&counter_id=${counterId}`, payload);
  },
  remove_cart_item: async (payload) => {
    return await httpClient.post(`cart/?remove_item=true&city_id=${cityId}&counter_id=${counterId}`, payload);
  },
  get_addresses: async (payload) => {
    return await httpClient.get(`address/`, payload);
  },
  add_address: async (payload) => {
    return await httpClient.post(`address/`, payload);
  },
  edit_address: async (payload) => {
    return await httpClient.put(`address/`, payload);
  },
  delete_address: async (id) => {
    return await httpClient.delete(`/address/?id=${id}`);
  },
  edit_user: async (payload) => {
    return await httpClient.put(`/user/`, payload);
  },
  check_mobile_exists: async (mobile) => {
    return await httpClient.put(`/user/?mobile_number=${mobile}`, {});
  },

  get_website_notification: async () => {
    return await httpClient.get("website-notification/");
  },


  generate_order: async (payload) => {
    return await httpClient.post(`/get_order_id/`, payload);
  },
  verify_payment: async (payload) => {
    return await httpClient.post(`/get_verify_payment/`, payload);
  },
  create_order: async (payload) => {
    return await httpClient.post(`/order/`, payload);
  },
  get_orders: async (payload) => {
    return await httpClient.get(`/order/`);
  },
  get_order_details: async (id) => {
    return await httpClient.get(`/order/?order_id=${id}`);
  },
  get_home_products: async (payload) => {
    return await httpClient.get(
      `/product/?pincode=${pincode}&filter_type=${payload.filter}`,
    );
  },
  get_banners: async () => {
    return await httpClient.get(`/banner/`);
  },
  get_feedbacks: async () => {
    return await httpClient.get(`/feedback/?user=true`);
  },
  create_feedback: async (payload) => {
    return await httpClient.post(`/feedback/`, payload);
  },
  delete_feedback: async (id) => {
    return await httpClient.delete(`/feedback/?feedback_id=${id}`);
  },
  delete_user_data: async () => {
    return await httpClient
      .patch('user/')
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  },

  delete_user: async () => {
    return await httpClient
      .delete('user/')
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  },
  notify_me: async ({ product_id, status, add_cart }) => {
    return await httpClient
      .post("notifyme/", {
        product_id,
        status,
        add_cart,
      })
      .then(res => res.data)
      .catch(err => {
        console.error(err);

        // ✅ If backend sent a response with message, return it
        if (err.response && err.response.data) {
          return err.response.data; // keeps { success: false, message: "...from backend..." }
        }

        // fallback if no response from server
        return { success: false, message: "Something went wrong" };
      });
  },
  get_notify_list: async () => {
    return await httpClient
      .get("notifyme/") // backend get method
      .then(res => res.data)
      .catch(err => {
        console.error(err);
        return { success: false, message: "Something went wrong" };
      });
  },
  delete_notify: async (id) => {
    return await httpClient
      .delete(`notifyme/${id}/`)   // backend delete method
      .then(res => res.data)
      .catch(err => {
        console.error(err);
        if (err.response && err.response.data) {
          return err.response.data;   // backend { success:false, message:"..." }
        }
        return { success: false, message: "Something went wrong" };
      });
  },

  get_counters: async (locationId) => {
    return await httpClient
      .get(`counter/?location_id=${locationId}`)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return { success: false, message: "Unable to fetch counters" };
      });
  },
    get_website_notification: async () => {
  return await httpClient
    .get("website_notification/")
    .then(res => res.data)
    .catch(err => {
      console.error(err);
      return { success: false, data: null };
    });
},
//  get_referral_coupon:async () => {
//    return await httpClient.get('referralCoupons/');
//   },

get_website_maintenance: async () => {
  return await httpClient
    .get("website_maintenance/") // your Django GET URL
    .then(res => res.data)
    .catch(err => {
      console.error(err);
      return { success: false, data: null };
    });
},
  apply_coupon: async ({ code, city_id, counter_id, chosen_product_id }) => {
    if (!city_id || !counter_id) {
        throw new Error("Coupon code, city, and counter are required");
    }
    return await httpClient.post(
        `cart/`,
        { code, chosen_product_id }, // POST body
        {
            params: {
                apply_coupon: true,
                city_id: city_id,
                counter_id: counter_id
            }
        }
    );
},

get_counter_areas: async (params) => {
  return await httpClient
    .get("counter_area/", { params })
    .then(res => {
      return res.data;
    })
    .catch(err => {
      return err;
    });
},
create_area_feedback: async (payload) => {
  return await httpClient
    .post("area_feedback/", payload)
    .then(res => res.data)
    .catch(err => {
      console.error(err);
      return { success: false, message: "Unable to submit feedback" };
    });
},
};


export const get_details_from_pincode = {
  get_address_details: async (payload) => {
    return axios.get(`https://api.postalpincode.in/pincode/${payload}`);
  },

};

export const getYearlyCoupon = async () => {
  return httpClient.get("yearly_coupon/");
};
export const getAllCoupons = async () => {
  return await httpClient.get("coupon/"); 

};


export const getReferralStats = async () => {
  return httpClient.get("referrals/stats/");
};

export const getReferralSettings = async () => {
  return httpClient.get("settings/");
};


export const getReferralCoupons = async () => {
  return httpClient.get("referralCoupons/");
};
